<template>
    <div v-if="isVisible" class="progress-bar-wrapper-page">
        <div class="progress-bar-wrapper">
            <div class="progress-bar-window">
                <div class="head">
                    <h4 class="modal-title">{{ title }}</h4>
                </div>
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="progress-bar-line">
                            <div class="progress-bar-line-status" :style="{ width: progress + '%' }"></div>
                            <div class="progress-text">{{ progress + '%' }}</div>
                        </div>
                        <div class="progress-bar-text">
                            {{ $t('progressBar.timeSpent') }}: {{ timeSpent }}
                        </div>
                        <div class="progress-bar-text">{{ $t('progressBar.timeLeft') }}: {{ timeLeft }}</div>
                        <button class="btn" @click="cancel">{{ $t('common.cancel') }}</button>
                    </div>
                    <div class="modal-footer"><slot name="footer"></slot></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { secsToReadableTime, unsavedHandler } from './helpers';
import store from '../../store';

export default {
    props: {
        cssClass: {
            type: String,
            required: false,
            default: 'normal-large-progress-bar-wrapper',
        },
    },

    data() {
        return {
            operationTitle: 'Saving assignments',
            showProgressBar: true,
            installationInProgress: true,
            uploadFileProgress: 77,
            showInlineProgress: true,
            statusData: {
                active_step: 1,
                progress: 55,
                steps: ['Step 1', 'Step 2', 'Step 3'],
            },
        };
    },

    computed: {
        ...mapState({
            isVisible: state => state.progressBar.isVisible,
            progress: state => state.progressBar.progress,
            timeElapsed: state => secsToReadableTime(state.progressBar.timeElapsed),
            timeSpent: state => secsToReadableTime(state.progressBar.timeSpent),
            timeLeft: state => secsToReadableTime(state.progressBar.timeLeft),
            title: state => state.progressBar.title,
        }),
    },
    methods: {
        cancel() {
            if (store.state.unsavedChanges) {
                let confirmMessage = {
                    confirmTitle: this.$t('common.unsavedTitle'),
                    confirmBody: this.$t('common.confirmInterruptSaving'),
                    confirmOk: this.$t('common.yes'),
                    confirmCancel: this.$t('common.no'),
                };

                return unsavedHandler(confirmMessage)
                    .then(() => {
                        store.state.progressBar.isCanceled = true;
                    })
                    .catch(() => {});
            }
        },
    },
};
</script>
